import { Link } from "react-router-dom"
import { isAppManager } from "../../helpers/staffRoleHelpers"
import styles from "../../styles/StaffProfileBox.module.css"

export default function StaffAssignedParticipants({
  assignedParticipants,
  selectedStaffId,
  loggedInStaffId,
  viewedStaffRole,
  containerClassName = "box-container",
  className = "box-rsi",
  numberClassName = "rsi-number",
  labelClassName = "rsi-label",
}) {
  // Keep "Assigned Participants" behavior intuitive:
  // own profile -> My Participants, other staff profile -> All Participants filtered to that staff.
  const isOwnProfile =
    ![selectedStaffId, loggedInStaffId].some((value) => value == null) &&
    String(selectedStaffId) === String(loggedInStaffId)

  const linkTo = isOwnProfile ? "/my-participants" : "/participant/list"

  const parsedViewedRole = Number(viewedStaffRole)
  const isViewedAppManager =
    Number.isInteger(parsedViewedRole) && isAppManager(parsedViewedRole)
  const canLink = isOwnProfile || !isViewedAppManager

  // Only pass preset filter state for cross-staff navigation into All Participants.
  const linkState =
    !isOwnProfile && selectedStaffId
      ? { presetStaffIds: [String(selectedStaffId)] }
      : undefined
  const ariaLabel = isOwnProfile
    ? "Go to My Participants"
    : "Go to All Participants"

  const content = (
    <>
      <span className={numberClassName}>{assignedParticipants}</span>
      <span className={labelClassName}>Assigned Participants</span>
    </>
  )

  return (
    <div className={containerClassName}>
      {/* Own profile links to My Participants; cross-profile App Manager is non-interactive. */}
      {canLink ? (
        <Link
          to={linkTo}
          state={linkState}
          className={className}
          aria-label={ariaLabel}
        >
          {content}
        </Link>
      ) : (
        <div className={`${className} ${styles.assignedBoxNonInteractive}`}>
          {content}
        </div>
      )}
    </div>
  )
}
